import "./App.css";
import axios from "axios";
import React, { useState, useEffect } from "react";
import { Theme } from "@radix-ui/themes";
import { BrowserRouter, Route, Routes, Navigate, Outlet } from 'react-router-dom';
import Register from "./components/Profile/Register.jsx";
import Login from "./components/Login/Login.jsx";
import Profile from "./components/Profile/Profile.jsx";
import '@radix-ui/themes/styles.css';
import Header from './components/Header.tsx';
import BannerTop from './components/BannerTop.tsx';
import LessonList from './components/Lesson/LessonList.tsx';
import Lesson from "./components/Lesson/Lesson.tsx";
import UploadVdo from "./components/backend/UploadVdo.jsx";
import UploadExam from "./components/backend/UploadExam.jsx";
import UploadEmployee from "./components/backend/UploadEmployee.jsx";
import ManageLesson from "./components/backend/ManageLesson.jsx";
import EditLesson from "./components/backend/EditLesson.jsx";
import Exam from "./components/Exam/Exam.tsx";
import LearningProgress from "./components/Profile/LearningProgress.jsx";
import UsersProgress from "./components/backend/UsersProgress.jsx";
import UploadCatalog from "./components/backend/UploadCatalog.jsx";
import UsersList from "./components/backend/UsersList.jsx";
import Password from "./components/Profile/Password.jsx";
import ProtectedRoute from "./components/ProtectedRoute.jsx";
import AdminRoute from "./components/AdminRoute.jsx";
import VersionChecker from "./utils/versionCheck.js";
const apiURL = `${process.env.REACT_APP_API_URL}/api`;

function App() {
  const [token, setToken] = useState(() => {
    return localStorage.getItem('token') || "";
  });

  // Initialize version checker
  /*React.useEffect(() => {
    new VersionChecker();
  }, []);*/

  const handleLogout = () => {
    localStorage.removeItem('token');
    setToken("");
  };

  if (!token) {
    return (
      <Theme radius="large">
        <BannerTop />
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login setToken={setToken} apiUrl={apiURL} />} />
            <Route path="/register" element={<Register />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </div>
      </Theme>
    );
  }

  return (
    <Theme>
      <Header onLogout={handleLogout}/>
      <BannerTop />
      <div className="App">
        <div className="container mx-auto p-4">
          <Routes>
            {/* User routes - protected but accessible to all authenticated users */}
            <Route path="/profile" element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            } />
            <Route path="/progress/:userId?" element={
              <ProtectedRoute>
                <LearningProgress />
              </ProtectedRoute>
            } />
            <Route path="/lessons" element={
              <ProtectedRoute>
                <LessonList />
              </ProtectedRoute>
            } />
            <Route path="/lesson/:id" element={
              <ProtectedRoute>
                <Lesson />
              </ProtectedRoute>
            } />
            <Route path="/exam/:id" element={
              <ProtectedRoute>
                <Exam />
              </ProtectedRoute>
            } />
            <Route path="/users/change-password" element={
              <ProtectedRoute>
                <Password />
              </ProtectedRoute>
            } />
            
            {/* Admin routes - only accessible to admin users */}
            <Route path="/backend/lessons" element={
              <AdminRoute>
                <ManageLesson />
              </AdminRoute>
            } />
            <Route path="/backend/lesson/:id" element={
              <AdminRoute>
                <EditLesson />
              </AdminRoute>
            } />
            <Route path="/backend/uploadVdo" element={
              <AdminRoute>
                <UploadVdo />
              </AdminRoute>
            } />
            <Route path="/backend/uploadExam/:lessonId" element={
              <AdminRoute>
                <UploadExam />
              </AdminRoute>
            } />
            <Route path="/backend/uploadEmployeeData" element={
              <AdminRoute>
                <UploadEmployee />
              </AdminRoute>
            } />
            <Route path="/backend/uploadCatalog" element={
              <AdminRoute>
                <UploadCatalog />
              </AdminRoute>
            } />
            <Route path="/backend/progress" element={
              <AdminRoute>
                <UsersProgress />
              </AdminRoute>
            } />
            <Route path="/backend/users" element={
              <AdminRoute>
                <UsersList />
              </AdminRoute>
            } />
            
            {/* Default route - redirect based on user role */}
            <Route path="/" element={
              <ProtectedRoute>
                {() => {
                  const user = JSON.parse(localStorage.getItem('user') || '{}');
                  return user.is_admin ? 
                    <Navigate to="/backend/lessons" replace /> : 
                    <Navigate to="/lessons" replace />;
                }}
              </ProtectedRoute>
            } />
          </Routes>
        </div>
      </div>
    </Theme>
  );
}

export default App;